import {
  InnerContentItem,
  InnerContentLink,
  OuterContentItem,
  PrimaryTag,
} from "@certn/cascadia-react";
import { SubHeading } from "@certn/cascadia-react/components/summary-card/sub-heading/SubHeading";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { formatDate } from "@certn/utils";
import { Trans, useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { getEmployerDate, getAddressWithUnit } from "./utils";
import { useCountryName } from "../../../../components/AddressInput";

export function EmploymentHistorySummaryField({
  field,
}: {
  field: components["schemas"]["EmploymentCheckField"];
}) {
  const { t } = useTranslation();
  const { applicantId } = useParams();
  const getCountryName = useCountryName();

  return (
    <>
      {field.value
        .sort((a) => (a.end_date ? 1 : -1))
        .map((employer, index) => {
          return (
            <OuterContentItem
              key={employer.id}
              title={employer.company_name}
              subtitle={getEmployerDate(employer)}
              tag={
                !employer.end_date && (
                  <PrimaryTag type="subtle">
                    <Trans>Current</Trans>
                  </PrimaryTag>
                )
              }
              testID={`employment-history-employment-${index + 1}`}
            >
              <SubHeading>
                <Trans>Employer details</Trans>
              </SubHeading>
              <InnerContentItem
                label={t("Company")}
                testID={`employment-history-employment-${index + 1}-company`}
              >
                {employer.company_name}
              </InnerContentItem>
              <InnerContentItem
                label={t("Website URL")}
                testID={`employment-history-employment-${index + 1}-url`}
              >
                {employer.employment_url}
              </InnerContentItem>
              <InnerContentItem
                label={t("Position")}
                testID={`employment-history-employment-${index + 1}-position`}
              >
                {employer.position}
              </InnerContentItem>
              <InnerContentItem
                label={t("Accomplishments / responsibilities")}
                testID={`employment-history-employment-${
                  index + 1
                }-accomplishments`}
              >
                {employer.accomplishments}
              </InnerContentItem>
              <InnerContentItem
                label={t("Start date")}
                testID={`employment-history-employment-${index + 1}-start-date`}
              >
                {formatDate(employer.start_date, "MMMM yyyy")}
              </InnerContentItem>
              {employer.end_date && (
                <InnerContentItem
                  label={t("End date")}
                  testID={`employment-history-employment-${index + 1}-end-date`}
                >
                  {formatDate(employer.end_date, "MMMM yyyy")}
                </InnerContentItem>
              )}
              <InnerContentItem
                label={t("Address")}
                testID={`employment-history-employment-${index + 1}-address`}
              >
                {getAddressWithUnit(employer.address)}
                <br />
                {employer.address.city} {employer.address.province_state},{" "}
                {getCountryName(employer.address.country) ??
                  employer.address.country}
                <br />
                {employer.address.postal_code}
              </InnerContentItem>
              <InnerContentLink
                url={`/apply/${applicantId}/employment-history?employer=${employer.id}`}
                testID={`employment-history-employment-${index + 1}-edit-link`}
              >
                <Trans>Edit</Trans>
              </InnerContentLink>
            </OuterContentItem>
          );
        })}
    </>
  );
}
